export default "__VITE_ASSET__ByNmQbYg__"